// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cesuan-body-content[data-v-52772b64]{width:70%;margin:0 auto;display:flex;justify-content:center;align-items:center;flex-direction:column}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
